import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import YogurtProduct from 'models/YogurtProduct'
import YogurtNutrition from './YogurtNutrition'
import YogurtPackage from './YogurtPackage'

const productOptions = {
  nutritionInfo: <YogurtNutrition />,
  packagingInfo: <YogurtPackage />,
  productTitle: 'Brand Specific Yogurt',
  model: YogurtProduct,
  validCategories: ['50'],
  validSubCategories: ['001', '002'],
  brandSpecific: true,
}

const Yogurt = () => <ProductForm product={productOptions} />

export default Yogurt
